import { Injectable } from '@angular/core';
import { isNil, reject } from 'lodash-es';

import { ApplicationAdapter } from 'application/application.adapter';
import { PhaseOutput } from 'phase/model/phase.output';
import { PhaseType } from 'phase/model/phase.type';
import { Phase } from 'phase/phase';
import { PhaseI18n } from 'phase/phase-i18n';
import { PhaseConverterPort } from 'phase/port/phase-converter.port';

@Injectable()
export class PhaseConverterAdapter
	extends ApplicationAdapter
	implements PhaseConverterPort
{
	public phaseAsEntity(output: PhaseOutput): Phase {
		if (!output) {
			return null;
		}

		return new Phase(
			output.id,
			PhaseType[output.type],
			output.position,
			output.sections.map((section) => section.id),
			output.organizationId,
			output.updateTimestamp,
			output.localizations.map((loc) => new PhaseI18n(loc.name, loc.locale))
		);
	}

	public phasesAsEntities(outputs: PhaseOutput[]): Phase[] {
		return reject(outputs, isNil).map((output) => this.phaseAsEntity(output));
	}
}
